import { Component } from '@angular/core';
import type { Routes } from '@angular/router';
import { allowUnauthenticatedGuard } from './auth/guards/allow-unauthenticated.guard';
import { loginProblemGuard } from './auth/guards/login-problem.guard';
import { rootRedirectGuard } from './guards/root-redirect.guard';

export const appRoutes: Routes = [
	{
		path: '',
		loadChildren: () => import('app/auth/login-page.routes').then((m) => m.loginPageRoutes),
		canActivate: [allowUnauthenticatedGuard],
		data: { hideSchoolSwitcher: true },
	},
	{
		// `/login` is the entry point the SSO Launch Gateway redirects students to
		// (…/login?instant_login=<provider>). It's a public alias of the root login page so the
		// gateway redirect lands on a real route and processOAuthRedirect() consumes the top-level
		// instant_login directly — instead of falling through the `**` wildcard to the protected
		// /main/passes and being rewritten into ?state=… by isAuthenticatedGuard.
		path: 'login',
		loadChildren: () => import('app/auth/login-page.routes').then((m) => m.loginPageRoutes),
		canActivate: [allowUnauthenticatedGuard],
		data: { hideSchoolSwitcher: true },
	},
	{
		path: 'home',
		canActivate: [rootRedirectGuard],
		component: Component,
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'google_oauth',
		loadChildren: () => import('app/auth/login-page.routes').then((m) => m.loginPageRoutes),
		canActivate: [allowUnauthenticatedGuard],
		data: { hideSchoolSwitcher: true },
	},
	{
		path: 'classlink_oauth',
		loadChildren: () => import('app/auth/login-page.routes').then((m) => m.loginPageRoutes),
		canActivate: [allowUnauthenticatedGuard],
		data: { hideSchoolSwitcher: true },
	},
	{
		path: 'auth0-callback',
		loadChildren: () => import('app/auth/login-page.routes').then((m) => m.loginPageRoutes),
		canActivate: [allowUnauthenticatedGuard],
		data: { hideSchoolSwitcher: true },
	},
	{
		// Why a sign-in can't finish. The guards that wait on sign-in send users here.
		path: 'login-problem',
		loadComponent: () => import('app/auth/components/login-problem/login-problem.component').then((m) => m.LoginProblemComponent),
		canActivate: [loginProblemGuard],
	},
	{
		path: 'main/student',
		loadChildren: () => import('./root-app/student.routes').then((m) => m.studentRoutes),
	},
	{
		path: 'main',
		loadChildren: () => import('./root-app/root-app.routes').then((m) => m.rootAppRoutes),
	},
	{
		path: 'parent',
		loadChildren: () => import('./parent/parent-app.routes').then((m) => m.parentAppRoutes),
	},
	{
		path: 'sign-out',
		loadChildren: () => import('app/sign-out/sign-out.routes').then((m) => m.SignOutRoutes),
	},
	{
		path: 'links',
		loadChildren: () => import('app/weblinks/weblinks.routes').then((m) => m.WeblinksRoutes),
		data: { hideSchoolSwitcher: true, hideScroll: false },
	},
	{
		// Redirect old /admin/* URLs to /main/admin/* preserving all path segments
		// This ensures users with bookmarked links or external references to old admin routes are seamlessly redirected
		path: 'admin',
		redirectTo: ({ url }) =>
			`/main/admin${url
				.slice(1)
				.map((segment) => `/${segment.path}`)
				.join('')}`,
		pathMatch: 'prefix',
	},
	{
		// Redirect /app/parent-sign-up to /parent-sign-up
		path: 'app/parent-sign-up',
		redirectTo: '/parent-sign-up',
		pathMatch: 'full',
	},
	{ path: '**', redirectTo: 'main/passes', pathMatch: 'full' },
];
